/**
 * 모바일 디바이스 감지 유틸리티
 */

/**
 * 모바일 브라우저 여부를 감지합니다.
 * @returns {boolean} 모바일 브라우저인 경우 true
 */
export const isMobileBrowser = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // iOS 감지
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return true;
  }

  // Android 감지
  if (/android/i.test(userAgent)) {
    return true;
  }

  // Windows Phone 감지
  if (/windows phone/i.test(userAgent)) {
    return true;
  }

  // 기타 모바일 디바이스 감지
  if (/Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(navigator.userAgent)) {
    return true;
  }

  // 터치 스크린 및 화면 크기 기반 추가 감지
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
  
  // 터치 지원과 작은 화면 크기를 모두 만족하는 경우 모바일로 간주
  if (hasTouch && isSmallScreen) {
    return true;
  }

  return false;
};

/**
 * 태블릿 디바이스 여부를 감지합니다.
 * @returns {boolean} 태블릿인 경우 true
 */
export const isTablet = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();

  // iPad 감지 (iOS 12 이하)
  const isIPad = /ipad/.test(userAgent);

  // iPadOS 13+ 감지 (macOS Safari로 위장되지만 터치 지원)
  // MacBook과 구분하기 위해 maxTouchPoints 확인
  const isIPadOS = navigator.maxTouchPoints > 0 &&
                   /macintosh/.test(userAgent) &&
                   'ontouchstart' in window;

  // Android 태블릿 감지
  const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent);

  return isIPad || isIPadOS || isAndroidTablet;
};

/**
 * 데스크톱 브라우저 여부를 감지합니다.
 * @returns {boolean} 데스크톱 브라우저인 경우 true
 */
export const isDesktopBrowser = (): boolean => {
  return !isMobileBrowser() && !isTablet();
};

/**
 * 운영체제를 감지합니다.
 * @returns {string} OS 종류 ("ios", "android", "macos", "windows", "linux", "unknown")
 */
export const getOS = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();

  // iOS 감지
  if (/iphone|ipad|ipod/.test(userAgent) && !(window as any).MSStream) {
    return "ios";
  }

  // Android 감지
  if (/android/.test(userAgent)) {
    return "android";
  }

  // macOS 감지
  if (/mac/.test(platform)) {
    return "macos";
  }

  // Windows 감지
  if (/win/.test(platform)) {
    return "windows";
  }

  // Linux 감지
  if (/linux/.test(platform)) {
    return "linux";
  }

  return "unknown";
};